import { useApolloClient, useQuery } from '@apollo/client';
import { GET_MEMBER_ACCREDITATIONS } from '../graphql/profile/queries';
import { useEffect, useState } from 'react';
import { IAccreditation } from '../interfaces/IAccreditation';
import _ from 'lodash';

export const useAccreditations = () => {
    const client = useApolloClient();

    const { data, loading, error } = useQuery(GET_MEMBER_ACCREDITATIONS, {
        client,
        fetchPolicy: 'no-cache',
    });

    const [accreditations, setAccreditations] = useState<IAccreditation[]>([]);

    useEffect(() => {
        if (data) {
            setAccreditations(data.memberAccreditations);
        }
    }, [loading, error, data]);

    const activeAccreditations = accreditations?.filter((a) => a.active) || [];
    const expiredAccreditations = accreditations?.filter((a) => a.expired) || [];
    const expiredAccreditationsByType = _.groupBy(
        expiredAccreditations,
        (acc) => acc.accreditationType.accreditationTypeId
    );
    const latestExpiredAccreditations: IAccreditation[] = _.map(
        expiredAccreditationsByType,
        (expired) => {
            const sorted = _.sortBy(expired, 'endDate');
            return sorted[0];
        }
    );
    const renewableAccreditationTypeIds: string[] =
        accreditations?.map((a) => a.accreditationType?.accreditationTypeId) || [];

    return {
        models: {
            loading,
            accreditations: {
                active: activeAccreditations,
                expired: latestExpiredAccreditations,
                renewable: renewableAccreditationTypeIds,
            },
        },
    };
};
